import StickyBox from "react-sticky-box";
import { User16 } from "../../imagepath";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../../../context/AuthContext";

// eslint-disable-next-line react/prop-types
export default function AdminSidebar({ sidebarVisible }) {
  const location = useLocation();

  const { logoutUser } = useContext(AuthContext);
  const logout = () => {
    logoutUser();
    console.log("User logged out");
  };

  return (
    <div className={`theiaStickySidebar ${sidebarVisible ? 'col-xl-3 col-lg-3' : 'd-none'}`}>
      <StickyBox offsetTop={20} offsetBottom={20}>
        <div className="settings-widget dash-profile">
          <div className="settings-menu">
            <div className="profile-bg">
              <div className="profile-img">
              </div>
            </div>
            <div className="profile-group">
              <div className="profile-name text-center">
                <h4>Administrator</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="settings-widget account-settings">
          <div className="settings-menu">
            <h3>Dashboard</h3>
            <ul>
              <li
                className={`nav-item ${location.pathname === "/admin/admin-dashboard" ? "active" : ""
                  }`}
              >
                <Link to="/admin/admin-dashboard" className="nav-link">
                  <i className="bx bxs-tachometer" />
                  Dashboard
                </Link>
              </li>
              <li
                className={`nav-item ${location.pathname === "/admin/teacher-quiz-dashboard" ? "active" : ""
                  }`}
              >
                <Link to="/admin/teacher-quiz-dashboard" className="nav-link">
                  <i className="bx bxs-bar-chart-alt-2" />
                  Teacher Quiz Dashboard
                </Link>
              </li>
              <li
                className={`nav-item ${location.pathname === "/admin/teachers-lists" ? "active" : ""
                  }`}
              >
                <Link to="/admin/teachers-lists" className="nav-link">
                  <i className="bx bxs-graduation" />
                  Teachers
                </Link>
              </li>
              <li
                className={`nav-item ${location.pathname === "/admin/school-lists" ? "active" : ""
                  }`}
              >
                <Link to="/admin/school-lists" className="nav-link">
                  <i className="bx bxs-graduation" />
                  School Lists
                </Link>
              </li>
              <li
                className={`nav-item ${location.pathname === "/admin/influences" ? "active" : ""
                  }`}
              >
                <Link to="/admin/influences" className="nav-link">
                  <i className="bx bxs-graduation" />
                  Influence Lists
                </Link>
              </li>
              <li
                className={`nav-item ${location.pathname === "/admin/drawing-entries" ? "active" : ""
                  }`}
              >
                <Link to="/admin/drawing-entries" className="nav-link">
                  <i className="bx bxs-trophy" />
                  Monthly Drawing Subscribers
                </Link>
              </li>
              {/* <li className={`nav-item ${location.pathname === '/admin/admin-courses' ? 'active' : ''}`}>
                <Link to="/admin/admin-courses" className="nav-link">
                  <i className="bx bxs-graduation" />
                  Courses
                </Link>
              </li>
              <li className={`nav-item ${location.pathname === '/admin/admin-qa' ? 'active' : ''}`}>
                <Link to="/admin/admin-qa" className="nav-link">
                  <i className="bx bxs-bookmark-alt" />
                  Question &amp; Answer
                </Link>
              </li> */}
            </ul>
            <h3>Account Settings</h3>
            <ul>
              {/* <li className={`nav-item ${location.pathname === '/admin/admin-setting' || location.pathname === '/admin/admin-change-password' || location.pathname === '/admin/admin-social-profile' || location.pathname === '/admin/admin-linked-accounts' || location.pathname === '/admin/admin-notification' ? 'active' : ''}`}>
                <Link to="/admin/admin-setting" className="nav-link ">
                  <i className="bx bxs-cog" />
                  Settings
                </Link>
              </li> */}
              <li className="nav-item">
                <Link to={process.env.REACT_APP_URL || "/"} className="nav-link" onClick={logout}>
                  <i className="bx bxs-log-out" />
                  Logout
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </StickyBox>
    </div>
  );
}
